import type {Class} from 'Catalyst/class';
import {type IconProps} from 'Catalyst/components/Icon';
import type {VariantProps} from 'tailwind-variants';
import {tv} from 'tailwind-variants';
import {default as Badge} from './Badge.svelte';

export enum BadgeColor {
  BRAND = 'brand',
  ERROR = 'error',
  INFO = 'info',
  NEUTRAL = 'neutral',
  SUCCESS = 'success',
  WARNING = 'warning',
}

export const badgeTvProps = tv({
  slots: {
    base: `
      rounded-[--badge-slots-base-border-radius]
      font-[--badge-slots-label-typography]
    `,
    label: `
      font-[--badge-slots-label-font-weight]
    `,
  },
  variants: {
    semantic: {
      brand: {
        base: `
          bg-[--badge-variants-semantic-brand-surface-default]
          text-[--badge-variants-semantic-brand-on-surface-default]
        `,
      },
      error: {
        base: `
          bg-[--badge-variants-semantic-error-surface-default]
          text-[--badge-variants-semantic-error-on-surface-default]
        `,
      },
      info: {
        base: `
          bg-[--badge-variants-semantic-info-surface-default]
          text-[--badge-variants-semantic-info-on-surface-default]
        `,
      },
      neutral: {
        base: `
          bg-[--badge-variants-semantic-neutral-surface-default]
          text-[--badge-variants-semantic-neutral-on-surface-default]
        `,
      },
      success: {
        base: `
          bg-[--badge-variants-semantic-success-surface-default]
          text-[--badge-variants-semantic-success-on-surface-default]
        `,
      },
      warning: {
        base: `
          bg-[--badge-variants-semantic-warning-surface-default]
          text-[--badge-variants-semantic-warning-on-surface-default]
        `,
      },
    },
    size: {
      sm: {
        base: `
          space-x-[--badge-variants-size-sm-item-spacing]
          px-[--badge-variants-size-sm-px]
          h-[--badge-variants-size-sm-height]
        `,
      },
      xs: {
        base: `
          space-x-[--badge-variants-size-xs-item-spacing]
          px-[--badge-variants-size-xs-px]
          h-[--badge-variants-size-xs-height]
        `,
      },
      md: {
        base: `
          space-x-[--badge-variants-size-md-item-spacing]
          px-[--badge-variants-size-md-px]
          h-[--badge-variants-size-md-height]
        `,
      },
    },
  },
  defaultVariants: {
    semantic: 'brand',
    size: 'sm',
  },
});

export type BadgeTVProps = VariantProps<typeof badgeTvProps>;

export type BadgeOwnProps = Partial<{
  leadingIcon: boolean;
  label: string;
  onClose: (e?: MouseEvent) => void;
  leadingEmojiGlyph: string;
  customLeadingIconGlyph: IconProps['name'];
}>;

export type BadgeProps = BadgeTVProps & BadgeOwnProps & Class;

export {Badge};
